import React from 'react'
import * as ReactDOM from 'react-dom'
import { Typography, withStyles, withWidth } from '@material-ui/core'
import original_picture from '../../media/article_reliability/newspaper_example.png'
import barometer_gauge from '../../media/article_reliability/barometer.svg'
import ImageMapper from 'react-image-mapper'
import { scrollToTop } from './ArticlePointMapSegment'
import FormLabel from '@material-ui/core/FormLabel'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import SVGInline from 'react-svg-inline'
import PopupDialog from '../PopupDialog'

export const ARTICLE_RELIABILITY = 'ARTICLE_RELIABILITY'

const styles = theme => ({
  caption: {
    margin: 20,
  },
  pointsBackground: {
    margin: '0 auto',
    flex: 1
  },
  pyramidContainer: {
    display: 'flex',
    maxWidth: 1260
  },
  pyramidImage: {
    width: '50%',
    maxWidth: 630,
    minHeight: 1200

  },
  pyramidSvgContainer: {
    height: 170,
  },
  pyramidChoices: {
    width: '50%',
    maxWidth: 630
  },
  sortableList: {},

  sortableItem: {
    margin: '10px',
    textAlign: 'justify',
    paddingLeft: 5,
    borderLeft: 'black solid',
    minHeight: 160
  },
  SortableItemHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    // margin: 5,
    padding: 3,
    textTransform: 'uppercase'
  },
  svg: {
    width: '100%',
    display: 'block',
    backgroundColor: '#EDEDED',
  },
  polygon: {
    fill: theme.palette.common.white,
    // fill: 'grey',
    stroke: theme.palette.divider,
    strokeWidth: 1,
  },
  svgText: {
    backgroundColor: '#F90000',
    color: 'white'
  },
  pyramidHeader: {
    backgroundColor: '#F90000',
    color: 'white',
    display: 'block',
    position: 'relative',
    padding: 5,
    textAlign: 'center'
  },
  symbolsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    // width: '50%'
  },
  symbolCard: {
    borderStyle: 'solid',
    borderWidth: 26,
    borderColor: 'brown',
    width: 300,
    height: 450,
    margin: 5,
    alignContent: 'center',
    position: 'relative',
  },
  symbolCardImage: {
    width: '100%',
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
    // margin: '0 5%'
    padding: '5%'
  },
  symbolCardText: {
    textAlign: 'center',
    padding: 10,
    top: '50%',
    transform: 'translate(0%,-50%)',
    position: 'absolute',
  },
  draggableText: {
    margin: 3
  },
  dropTarget: {
    // backgroundColor: 'green',
  },
  barometerAgree: {},
  barometerAgreeQuestion: {
    width: '100%'
  },
  barometerGauge: {
    maxWidth: 600,
    margin: '0 auto',
    position: 'fixed',
    right: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    padding: '45px 80px',
    backgroundColor: '#CA8456'
  },
  barometerTitle: {
    textAlign: 'center',
    color: '#fff7f7',
    fontSize: 19,
    fontWeight: 'bold',
    marginBottom: 20,

  },
  formsetRow: {
    justifyContent: 'space-around'
  },
  formsetColumn: {
    width: '25%',
    margin: 0,
    textAlign: 'center',
  },
  newspaper: {
    maxHeight: '70vh'
  },
  newspaperContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    /* align-content: center, */
    alignItems: 'center',
  },
  questionsContainer: {
    padding: 20,
    maxWidth: 800,
    margin: '0 auto'
  },
  articleTitleBorder: {
    backgroundColor: 'black',
    height: 5,
    width: '30%',
    margin: '30px 0px'
  },
})

const image_map = [
  { // Source
    x1: 160, y1: 50, x2: 410, y2: 90,
    title: 'SOURCE',
    question: 'Where is this source published? What are other (similar) sources published in this media? Who is the target audience?'
  },
  { // Title
    x1: 160, y1: 90, x2: 580, y2: 180,
    title: 'TITLE',
    question: 'What experiences (professional, life, educational, etc.) give the author credits and qualifications to wrote on this topic?'
  },
  { // Author
    x1: 160, y1: 290, x2: 580, y2: 390,
    title: 'AUTHOR',
    question: 'How does it reflect author\'s background? What are the key words?'
  },
  { // Date
    x1: 410, y1: 50, x2: 580, y2: 90,
    title: 'DATE',
    question: 'Is this a new source about the recent event(s)? Or is this a new source about the past event that has a significant meaning now?'
  },
]

const barometer_questions = [
  'The author is well informed.',
  'The author has other references related to this field.',
  'The author is being peer-reviewed or/and positively recognized by other respected members from the field.',
  'The author is open to dialogue and further communication with regards to the topic.',
  'The authors refers to other sources and offers links to confirm their statements.',
  'The source is consistent with facts included.',
  'The account fairly represents key and multiple perspectives of the events.',
  'The account offers generally complete story of the event(s).',
  'The account is based on accurate and trustworthy sources of information.',
  'The account arrives at conclusions that are warranted given the amount and nature of the available historical evidence.',
  'Interpretation is based on analytical sources rather than emotions.'
]

function mapFromChildren (questions) {
  let map = {
    name: 'hero_map',
    areas: []
  }
  let i = 0
  for (let child of questions) {
    // case study content
    map.areas.push({
      name: i++,
      coords: [child.x1, child.y1, child.x2, child.y2],
      shape: 'rect',
      question: child.question,
      title: child.title,
      answered: false,
      answer: null,
      preFillColor: 'rgba(255, 255, 255, 0.5)',
    })
  }
  return map
}

function fillMapWithDefaults (map) {
  for (let area of map.areas) {
    if (!area.shape) {
      area.shape = 'circle'
    }
    if (!area.preFillColor) {
      area.preFillColor = 'rgba(255, 0, 0, 0.5)'
    }
    if (!area.preFillColor) {
      area.preFillColor = 'rgba(255, 255, 255, 0.5)'
    }
  }
  return map
}

class ArticleReliability extends React.Component {
  state = {
    map: null,
    correct: false,
    currentArea: null,
    answers: [],
    avgAnswer: null
  }

  componentDidMount () {
    let map = fillMapWithDefaults(mapFromChildren(image_map))
    let answers = []
    for (let question of barometer_questions) {
      answers.push({ value: undefined, question })
    }
    this.setState({ map, answers })

    let rect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
    setTimeout(() => scrollToTop(this), 500)
    if (!this.boundingRect) {
      this.boundingRect = rect
      this.forceUpdate()
    } else {
      this.boundingRect = rect
    }

    let gauge
    for (let j = 0; j < 4; j++) {
      gauge = document.getElementById('gcredible' + j.toString())
      gauge.setAttribute(
        'opacity', '0.3'
      )
    }
  }

  isFinished () {
    let i = 0
    let avg = 0
    for (let an of this.state.answers) {
      if (an.value) {
        i++
        avg += parseInt(an.value, 10)
      }
    }
    let gauge
    if (i >= this.state.answers.length) {
      for (let j = 0; j < 4; j++) {
        gauge = document.getElementById('gcredible' + j.toString())
        gauge.setAttribute(
          'opacity', '0.3'
        )
      }
      gauge = document.getElementById('gcredible' + Math.floor(4 - (avg / i)))
      gauge.setAttribute(
        'opacity', '1'
      )

      this.setState({ correct: true, avgAnswer: avg / i })
    }
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    this.boundingRect = ReactDOM.findDOMNode(this)
      .getBoundingClientRect()
  }

  handleClick = (area, index, event) => {
    let newMap = this.state.map

    newMap.areas[area.name].preFillColor = 'rgba(0,0,0,0)'
    newMap.areas[area.name].anwsered = true
    let correct = this.checkCorrect(newMap)
    this.setState({ map: newMap, correct, currentArea: area })
  }

  checkCorrect (newMap) {
    for (let area of newMap.areas) {
      if (!area.anwsered) {
        return false
      }
    }
    return true
  }

  handleChange (index) {
    return (event) => {
      let answers = this.state.answers
      console.log(event.target.value, index, answers[index])
      answers[index].value = event.target.value

      this.setState({ answers })
      this.isFinished()
    }
  }

  render () {
    let {
      className, classes
      // ...props
    } = this.props
    let { map, currentArea } = this.state

    const mapWidth = 600
    const imgWidth = 762


    return <div className={className}>
      {map &&
      <div className={classes.newspaperContainer}>

        <Typography variant={'h1'} className={classes.caption}>
          Explore the most important elements of the article.
        </Typography>
        <ImageMapper src={original_picture} map={map}
                     width={mapWidth}
                     imgWidth={imgWidth}
                     lineWidth={0}
                     fillColor={'rgba(100, 100, 100, 0.5)'}
          // onLoad={() => this.load()}
          //                    onMouseEnter={area => this.enterArea(area)}
          //                    onMouseLeave={area => this.leaveArea(area)}
                     onMouseMove={() => null}
          // onImageMouseMove={evt => this.moveOnImage(evt)}
                     onClick={(area) => {
                       this.handleClick(area, null, null)
                     }}
                     className={classes.newspaper}
        />
        <Typography className={classes.caption}>
          Source: New York Post, April 30, 1975, Vietnam War is Over
        </Typography>
      </div>
      }
      <div className={classes.questionsContainer}>
        <div>
          <Typography variant={'h1'}>
            INFORMATION BAROMETER
          </Typography>
          <Typography>
            In further assessment and close reading one interacts with the text, asks questions and the context of the
            source. Choose a text that you would like to assess and use the information barometer below to reflect
            reliability and credibility.
          </Typography>
        </div>
        {barometer_questions.map((item, index) => {

          if (!this.state.answers[index]) {
            return ''
          }
          return <div key={index} className={classes.barometerAgree}>
            <Typography variant={'h6'}>
              {item}
            </Typography>
            <FormControl component="fieldset" className={classes.barometerAgreeQuestion}>
              <FormLabel component="legend">
                Do you:
              </FormLabel>
              <RadioGroup
                aria-label="position"
                name="position"
                value={this.state.answers[index].value}
                onChange={this.handleChange(index)}
                row
                className={classes.formsetRow}
              >
                <FormControlLabel
                  value="1"
                  control={<Radio color="primary"/>}
                  label="STRONGLY DISAGREE"
                  labelPlacement="top"
                  className={classes.formsetColumn}
                />
                <FormControlLabel
                  value="2"
                  control={<Radio color="primary"/>}
                  label="DISAGREE"
                  labelPlacement="top"
                  className={classes.formsetColumn}
                />
                <FormControlLabel
                  value="3"
                  control={<Radio color="primary"/>}
                  label="AGREE"
                  labelPlacement="top"
                  className={classes.formsetColumn}
                />
                <FormControlLabel
                  value="4"
                  control={<Radio color="primary"/>}
                  label="STRONGLY AGREE"
                  labelPlacement="top"
                  className={classes.formsetColumn}
                />
              </RadioGroup>
            </FormControl>
            <hr className={classes.articleTitleBorder}/>
          </div>
        })}
      </div>

      <div className={classes.barometerGauge}>
        <Typography className={classes.barometerTitle}>
          THIS BAROMETER DYNAMICALLY REFLECT RELIABILITY AND CREDIBILITY
        </Typography>
        <SVGInline svg={barometer_gauge} component={'div'} width={'100%'}
        />
      </div>
      {currentArea &&
      <PopupDialog actionName={currentArea.title} message={currentArea && currentArea.question}
                   open={!!this.state.currentArea}
                   disableBackdropClick={true}
                   disableEscapeKeyDown={true}
                   handleClose={() => this.setState({ currentArea: null })}
                   handleYes={() => {
                     console.log('Yes')

                   }}
      />}
    </div>
  }
}

export default withWidth()(withStyles(styles, { withTheme: true })(
  ArticleReliability
))
